/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleALeftIcon16Solid = forwardRef('ArrowShapeTriangleALeftIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11 11.348V4.651a.9.9 0 0 0-1.388-.756l-5.19 3.349a.9.9 0 0 0 0 1.512l5.19 3.348A.9.9 0 0 0 11 11.348Z" })));
});
